module.exports = __webpack_public_path__ + "media/Video 103.eb1a5b5a.mp4";